(function () {
  function initProductVideoSpecs(scope) {
    (scope || document).querySelectorAll('.tg-product-video-specs').forEach(function (section) {
      if (section.dataset.videoSpecsReady === 'true') return;
      section.dataset.videoSpecsReady = 'true';
      var modal = section.querySelector('[data-tg-video-modal]');
      var player = modal && modal.querySelector('video');
      var openButtons = section.querySelectorAll('[data-tg-video-open]');
      var closeButtons = section.querySelectorAll('[data-tg-video-close]');
      var lastFocus = null;

      function openModal() {
        if (!modal) return;
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.documentElement.classList.add('tg-product-video-modal-open');
        var close = modal.querySelector('.tg-product-video-modal__close');
        if (close) close.focus();
        if (player) {
          var promise = player.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        }
      }
      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        document.documentElement.classList.remove('tg-product-video-modal-open');
        if (player) {
          player.pause();
          try { player.currentTime = 0; } catch (error) {}
        }
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }
      openButtons.forEach(function (button) { button.addEventListener('click', openModal); });
      closeButtons.forEach(function (button) { button.addEventListener('click', closeModal); });
      section.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProductVideoSpecs(document); }, { once: true });
  } else {
    initProductVideoSpecs(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initProductVideoSpecs(event.target); });
})();